Vue.component('ack-alpha-ai-collection', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-alpha-ai-collection',
    mounted() {
  
      
    },
    props:{
      collectionItems: { // :product-info
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      //...Vuex.mapGetters('shop', ['productList']),
      
      carouselOptions(){
        let opt = {
          arrows: true,
          dots: false,
          infinite: false,
          slidesToShow: this.isMobile? 1 : 4,
          slidesToScroll: 1,
          autoplay: false,
          speed: 500,
          autoplaySpeed: 0,
          cssEase: 'linear',
          initialSlide: -1,
        }
  
        return opt
      }
    },
    data() {
      return {

      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      // ...Vuex.mapActions('shop', ['sayHi', 'closeAllMobileDropdowns']),
      
      onAddToCartClick({shopifyId, variantId, sellingPlanId }){
        appLog.log('onAddToCartClick', LOG_TYPE.debug)
        appLog.log({shopifyId, variantId, sellingPlanId }, LOG_TYPE.debug)
      }
      
  
    },
    beforeDestroy() {
      
    },
    watch: {
      prop1: {
        handler() {
          
          
        },
        deep: false
      }
    }
  })